module.exports = __webpack_public_path__ + "static/media/Pin.232f4a7e.png";